export default __webpack_public_path__ + "static/media/logo.42e174a0.svg";